export default __webpack_public_path__ + "static/media/granizo.2726e6d1.svg";